import getPriceBillingConfig from '../lib/getPriceBillingConfig';
import useCheckoutState from './useCheckoutState';
import useSelectedPrice from './useSelectedPrice';

/**
 * Pricing display fields resolved from the buyer's SELECTED price, with the
 * legacy product-level scalars as the fallback for pre-migration products that
 * have no prices[]. On a multi-price product these live on the price (and its
 * billing config), not the stale product.* scalars — so the module-presence
 * checks (checkHasProductModules / getProductModules) must read these.
 * Mirrors the same resolution useCartCost does internally.
 */
export default function useEffectivePricing() {
  const { product } = useCheckoutState();
  const selectedPrice = useSelectedPrice();
  const config = getPriceBillingConfig(selectedPrice);

  // TODO(M14): drop the `product?.*` fallbacks (flat legacy pricing) once the
  // prices[] backfill migration has run — every product will then have a
  // selectedPrice and these should read from it exclusively.
  return {
    effectiveDiscountedFromPrice: selectedPrice
      ? selectedPrice.discountedFromPrice
      : product?.discountedFromPrice,
    effectiveTrialPeriodDays: selectedPrice ? config?.trialPeriodDays : product?.trialPeriodDays,
    effectiveStartDate: selectedPrice ? config?.startDate : product?.startDate,
  };
}
